module.exports = __webpack_public_path__ + "img/lc_fgyl.f878b874.svg";